import { v4 as uuid } from 'uuid';
import { mergeMap, of } from "rxjs";
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as FlatActions from '@medsurf/flat-actions';
import * as FlatStates from '@medsurf/flat-states';
import * as FlatModels from "@medsurf/flat-models";

@Injectable()
export class FreeFormStyleEntityFacade {
  constructor(protected store: Store) {
  }

  //<editor-fold desc="Selectors">

  //</editor-fold>

  //<editor-fold desc="Requests">
  
  static getNewInstance(id: string,
                        annotation: FlatModels.AnnotationEntityModels.FreeForm,
                        strokeWidth = 2,
                        width = 0.1,
                        height = 0.2) {
    const freeFormStyle: FlatModels.FreeFormStyleEntityModels.FreeFormStyle = {
      id,
      width,
      height,
      strokeWidth,
      closePath: null,
      smooth: false,
      background: false,
      backgroundInBorderColor: false,
      strokeColor: null,
      opacity: null,
      startType: FlatModels.AnnotationEntityModels.TipType.enum.none,
      endType: FlatModels.AnnotationEntityModels.TipType.enum.none,
      endRadius: null,
      startRadius: null,
      color: null,
      dash: null,
      angle: 0,
      smoothFactor: 0.3,
      freeForm: annotation.id
    };
    return freeFormStyle;
  }
  
  static addFreeFormStyle(store: Store,
                          id: string,
                          annotation: FlatModels.AnnotationEntityModels.FreeForm,
                          strokeWidth = 2,
                          width = 0.1,
                          height = 0.2) {
    // Get New Instance
    const freeFormStyle = FreeFormStyleEntityFacade.getNewInstance(id, annotation, strokeWidth, width, height);
    
    // Add Annotation Label
    return store.dispatch(new FlatActions.FreeFormStyleEntityActions.AddEntity(freeFormStyle)).pipe(
      mergeMap((data) => of({data, freeFormStyle})),
    );
  }
  
  static getCopyInstance(store: Store,
                         id: string,
                         annotation: FlatModels.AnnotationEntityModels.FreeForm) {
    // Get Data
    const typedFreeFormStyle = store.selectSnapshot(FlatStates.FreeFormStyleEntityState.typedEntities$);
    
    // Get FreeFormStyle 
    const freeFormStyle = structuredClone(typedFreeFormStyle[id]);
    
    // Update FreeFormStyle 
    freeFormStyle.id = uuid();
    freeFormStyle.freeForm = annotation.id;
    
    return freeFormStyle;
  }

  //</editor-fold>
}
